module.exports = __webpack_public_path__ + "img/wechatMini.9b14c042.jpg";